module.exports = __webpack_public_path__ + "img/charging_start_tip1.621deddb.png";